export default [
	{
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Date Time',
		width: 145,
		align: 'center',
		scopedSlots: {customRender: 'datetime'}
	}, {
		dataIndex: 'type',
		key: 'type',
		align: 'center',
		title: 'Type',
		width: 100,
		scopedSlots: {customRender: 'type'}
	}, {
		dataIndex: 'client',
		key: 'client',
		title: 'Client',
		scopedSlots: {customRender: 'client'}
	}, {
		key: 'receiver',
		dataIndex: 'bank',
		title: 'Bank',
		scopedSlots: {customRender: 'receiver'}
	}, {
		key: 'sender',
		title: 'Sender',
		scopedSlots: {customRender: 'sender'}
	}, {
		dataIndex: 'amount',
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		dataIndex: 'ref_number',
		key: 'ref_number',
		title: 'Ref #',
		scopedSlots: {customRender: 'refNumber'}
	}, {
		dataIndex: 'status',
		key: 'status',
		title: 'Status',
		width: 100,
		scopedSlots: {customRender: 'status'}
	}, {
		title: '',
		key: 'action',
		scopedSlots: {customRender: 'action'}
	}
]
